// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"modal_disable-scroll__2IlrU"};